import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Navbar from "../components/Navbar";
import { API } from "../context/AuthContext";
import { toast } from "sonner";

export default function ProMaxPayPal() {
  const [params] = useSearchParams(); const nav = useNavigate(); const [cfg, setCfg] = useState(null);
  const orderId = params.get("order_id"), amount = params.get("amount"), pid = params.get("payment_id");
  useEffect(() => { axios.get(`${API}/paypal/config`).then(r => setCfg(r.data)).catch(() => setCfg({ configured: false })); }, []);
  const cancelUrl = pid ? `/payment/cancel?order_id=${pid}` : "/organizer/promax?cancelled=1";
  return (
    <div className="min-h-screen grain-bg"><Navbar variant="pro" />
      <section className="pt-28 pb-24 max-w-md mx-auto px-5" data-testid="promax-paypal">
        <div className="rl-card p-6 text-center">
          <div className="pill-badge inline-flex mb-3">PAGAMENTO PAYPAL · PROMAX</div>
          <h1 className="font-display font-black text-2xl mb-1" data-testid="promax-paypal-total">Totale €{amount}</h1>
          <p className="text-xs text-slate-500 mb-5">IVA inclusa · la licenza si attiva solo dopo la conferma del pagamento da parte di PayPal</p>
          {cfg?.configured && cfg.client_id ? (
            <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "EUR", intent: "capture" }}>
              <PayPalButtons style={{ layout: "vertical", color: "black", label: "pay" }} createOrder={async () => orderId}
                onApprove={async () => { try { const { data } = await axios.post(`${API}/promax/paypal/${orderId}/capture`); nav(data.status === "COMPLETED" ? `/payment/success?order_id=${data.order_id}` : `/payment/cancel?order_id=${data.order_id}&failed=1`); } catch (e) { toast.error(e.response?.data?.detail || "Pagamento PayPal non completato"); if (pid) nav(`/payment/cancel?order_id=${pid}&failed=1`); } }}
                onCancel={() => nav(cancelUrl)} onError={() => toast.error("PayPal non disponibile. Riprova o usa la carta.")} />
            </PayPalScriptProvider>
          ) : <div className="text-sm text-slate-400" data-testid="paypal-unavailable">PayPal non disponibile al momento.</div>}
          <button className="text-xs text-slate-400 underline mt-5 min-h-[44px]" onClick={() => nav(cancelUrl)} data-testid="promax-paypal-cancel">Annulla e torna indietro</button>
        </div>
      </section>
    </div>
  );
}
